<template>
  <div
    :id="props.project.id"
  	v-if="!props.isprintView"
    ref="projectEl"
    class="sidebar-group"
    :class="{ open: props.isopen }"
    :style="sidebarGroupStyle"
    @click="emit('update', props.project.id)"
  >
    <div class="flex items-center justify-between w-full px-2">
      <div class="flex items-center gap-2">
        <ChevronRight :size="16" v-if="!props.isopen"/>
        <ChevronDown  :size="16" v-if="props.isopen"/>
        {{ props.project.name }}
      </div>

      <div v-show="props.isopen" class="flex items-center">
        <Button variant="ghost" size="icon" @click.stop="activeFilterMenu = !activeFilterMenu">
          <Filter :size="16" />
        </Button>
        <Button variant="ghost" size="icon" @click.stop="activePrintMenu = !activePrintMenu">
          <Printer :size="16"/>
        </Button>
      </div>
    </div>

    <ResourceFilterCallout
      :id="`filter-${props.project.id}`"
      :target="projectEl"
      :show="activeFilterMenu"
      :resourceFilter="props.resourceFilter"
      :users="props.users"
      @close="activeFilterMenu = false"
      @updateFilter="(data) => emit('updateResourceFilter', props.project.id, data)"
      @openPersonModal="activeFilterMenu = false; showPersonModal = true"
    />

    <PersonSelectionModal
      :open="showPersonModal"
      :project="props.project"
      :users="props.users"
      :bookings="props.bookings"
      :projects="props.projects ?? []"
      :resourceFilter="props.resourceFilter"
      @apply="(ids) => { emit('updateResourceFilter', props.project.id, { ...props.resourceFilter, selection: 1, individual: ids }); showPersonModal = false }"
      @cancel="showPersonModal = false"
    />

    <PrintCallout
      :id="`print-${props.project.id}`"
      :target="projectEl"
      :show="activePrintMenu"
      :project="props.project"
	    @close="activePrintMenu = false"
      @print-view="handlePrintAction"
    />
  </div>

  <div v-if="props.isopen">
    <div v-for="(u, idx) in filteredUsers" :key="u.id" :style="userRowStyle(idx)" class="content" :class="{printview: props.isprintView}">
      <div class="inner">{{ u.firstname }} {{ props.isprintView ? u.lastname : u.short }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { getRowHeight, hasBookings, applyResoureFilter } from "./planner.js"
import ResourceFilterCallout from './ResourceFilterCallout.vue'
import PersonSelectionModal from './PersonSelectionModal.vue'
import PrintCallout from './PrintCallout.vue'
import { Button } from "@/components/ui/button"
import { ChevronRight, ChevronDown, Printer, Filter } from "lucide-vue-next"

const props = defineProps(['project', 'users', 'bookings', 'isopen', 'resourceFilter', 'isprintView', 'projects'])
const emit = defineEmits(['update', 'updateResourceFilter', 'printView'])

const projectEl = ref(null)
const activeFilterMenu = ref(false)
const activePrintMenu = ref(false)
const showPersonModal = ref(false)

const filteredUsers = computed(() =>
  props.users.filter((u: any) => applyResoureFilter(props.resourceFilter, props.project, u))
)

const sidebarGroupStyle = computed(() => ({ height: `${getRowHeight(props.isprintView)}px` }))

function userRowStyle(_idx: number | string) {
  return { height: `${getRowHeight(props.isprintView)}px` }
}

// Watch for selection logic as before
watch(() => props.resourceFilter.selection, (newVal: number) => {
  if (newVal === 0) {
    props.resourceFilter.hasBookings = hasBookings(props.project, props.users, props.bookings)
  } else if (newVal === 2) {
    props.resourceFilter.hasBookings = props.users.map((u: any) => u.id)
  }
})

function handlePrintAction(start: string, end: string) {
    emit('printView', props.project, start, end);
}
</script>

<style scoped>

.sidebar-group {
  border: 1px solid #ccc;
  overflow: hidden;
  transition: height 0.3s ease;
  display: flex;
}

.sidebar-group.spacer {
  background-color: rgb(250, 250, 250);
}

.content {
  padding: 8px;
  background: #fff;
}

.content.printview {
  display: flex;
  align-items: self-end;
  padding-left: 10px;
  height: 100%;
  font-size: 12px;
  border-bottom: 1px solid rgb(229 231 235 / var(--tw-border-opacity, 1)) !important;
}

.toggle {
  font-size: 0.8em;
}

</style>
